import {BankCallbackPage} from "./BankCallbackPage";
import {LoginButton} from "../../LoginButton/LoginButton";
import {Link} from "react-router-dom";
import React from "react";

export const BankCallbackWrapper = ({userInfo, errorCode, lang, clientCtx}) => {

    return <>
        <BankCallbackPage userInfo={userInfo} errorCode={errorCode} lang={lang}>
            {errorCode.length == 0 ?
                <p>{userInfo['name']} {userInfo['family_name']}!</p> :
                <LoginButton clientCtx={clientCtx}/>
            }
        </BankCallbackPage>
        <Link to='/'>Back to client selection</Link>
    </>
}
